// extracted by mini-css-extract-plugin
export default {"dialog":"cQgNjiMPYICMY1I7","subHeader":"Yw_2DzS7Do9lwlBP","header":"Ryz4qsQEy2IxILTd","warning":"K5aGhneRgLvskzLa","texts":"kKlsKdR9JVYv0a3V","footer":"NFpZCnEWEsEbkyg9"};